import React, { useEffect, useLayoutEffect } from 'react';
import { DateTime } from 'luxon';

import Stack from '@mui/material/Stack';
import ZeroStateView from 'components/ZeroStateView';

import ReportProblemLink from 'components/ReportProblemLink';
import { dismissErrorPage, errorsBlackList, treatAsWarning } from 'utils/core/bugsnag';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

let loopBreakerTime = DateTime.now();

type Props = {
  error: Error;
  clearError?: () => void;
};

const FallbackComponent = ({ error, clearError }: Props) => {
  useEffect(() => dismissErrorPage(), []);

  useLayoutEffect(() => {
    const context = `${error.name}:${error.message}`;
    if (
      (DateTime.now().diff(loopBreakerTime, 'minutes').minutes > 5 &&
        errorsBlackList.find((mask) => (typeof mask === 'string' ? context.includes(mask) : mask.test?.(context)))) ||
      treatAsWarning.find((mask) => (typeof mask === 'string' ? context.includes(mask) : mask.test?.(context)))
    ) {
      loopBreakerTime = DateTime.now();
      clearError?.();
    }
  }, [error, clearError]);

  return (
    <Paper
      sx={{
        padding: 2,
        zIndex: 1000,
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexFlow: 'column wrap',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
      }}
    >
      <ZeroStateView
        size='small'
        qIllustration='planeCrash'
        subtitle='Oops! Something went wrong.'
        description='We are sorry for the inconvenience.'
        button={
          <Stack gap={1}>
            <Button variant='contained' onClick={() => window.location.reload()}>
              Try Again
            </Button>

            <ReportProblemLink type='button' feedbackSubject='report react crash'>
              Send Feedback
            </ReportProblemLink>
          </Stack>
        }
      />
    </Paper>
  );
};

FallbackComponent.whyDidYouRender = false;

export default FallbackComponent;
